import React, { Component } from 'react';
import moment from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { Modal, ModalBody, Form, TabContent, TabPane, Nav, NavItem, NavLink, Input, Collapse, Button, Alert } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faExclamationCircle, faTimesCircle, faDownload, faSpinner } from '@fortawesome/free-solid-svg-icons';
import TransferenceListContainer from '../../components/transference-list-container/TransferenceListContainer';
import TransferenceListFilter from '../../components/transference-list-filter/TransferenceListFilter';
import DashBoardHeaderContainer from '../../components/dashboard-header-container/DashBoardHeaderContainer'
import { Permissions, TransferenceStatus } from '@autofact-lib/operation-lib-model-notary-platform';
import { Link, withRouter } from "react-router-dom";

import FilterIcon from '../../theme/assets/filter_conces.svg';
import DeclarationsIcon from '../../theme/assets/declarations-icon.svg';
import DeclarationsIconBlack from '../../theme/assets/declarations-icon-black.svg';
import GreenCheckIcon from '../../theme/assets/green-check-icon.svg';
import GrayCloseIcon from '../../theme/assets/gray-close-icon.svg';
import CalendarIcon from '../../theme/assets/calendar-icon.svg';
import CheckAccess from "../../components/check-access/CheckAccess";
import AuthService from '../../services/AuthService';
import BackendApiService from '../../services/BackendApiService';

import './TransferenceList.style.css';

const alertIconMap = {
    success: { icon: faCheckCircle, color: 'text-success' },
    warning: { icon: faExclamationCircle, color: 'text-warning' },
    danger: { icon: faTimesCircle, color: 'text-danger' },
};

class TransferenceList extends Component {

    constructor(props) {
        super(props);
        const { tabsDefinition, listFilters, recordCount } = TransferenceList.getDefinition();
        this.state = {
            tabsDefinition: Object.assign({}, tabsDefinition),
            activeTab: tabsDefinition.forApproval.id,
            filtersCollapsed: true,
            isMessageVisible: false,
            message: {},
            listFilters: { ...listFilters },
            recordCount: { ...recordCount },
            listSorted: {
                full: Object.assign({}, tabsDefinition.full.sorted),
            },
            showModal: false,
            loadingFetchDeclaration: false,
            formData: {
                DATE_FROM: null,
                DATE_TO: null,
                DATE_RANGE: ''
            },
            alert: null,
            downloadUrl: null,
            invalidDate: false,
        };

        this.toggleFilters = this.toggleFilters.bind(this);
        this.onDismiss = this.onDismiss.bind(this);
        this.showSuccesMessage = this.showSuccesMessage.bind(this);
        this.showErrorMessage = this.showErrorMessage.bind(this);
        this.showDetailsInTabGeneric = this.showDetailsInTabGeneric.bind(this);
        this.buildFilters = this.buildFilters.bind(this);
        this.setFiltersCallback = this.setFiltersCallback.bind(this);
        this.toggleShowModal = this.toggleShowModal.bind(this);
        this.resetModal = this.resetModal.bind(this);
        this.handleFormDataChange = this.handleFormDataChange.bind(this);
        this.onDateRangeSelected = this.onDateRangeSelected.bind(this);
        this.handleDownload = this.handleDownload.bind(this);
        this.handleClearAlert = this.handleClearAlert.bind(this);
        this.currentTableRef = React.createRef();
        this.filterComponentRef = React.createRef();
    }

    static getDefinition() {
        const tabsDefinition = {
            forApproval: {
                id: 'forApproval',
                title: 'Contratos por aprobar',
                filters: { STATUS: TransferenceStatus.NOTARY_APPROVAL.id }
            },
            repertory: {
                id: 'repertory',
                title: 'Repertorio',
                filters: { STATUS: TransferenceStatus.REPERTORY.id }
            },
            representation: {
                id: 'representation',
                title: 'Representación',
                filters: { STATUS: TransferenceStatus.STATUS_ADVANCED_SIGNATURE_REPRESENTATIVE.id }
            },
            forSign: {
                id: 'forSign',
                title: 'Contratos por firmar',
                filters: { STATUS: [TransferenceStatus.NOTARY.id, TransferenceStatus.PACKING.id] }
            },
            signed: {
                id: 'signed',
                title: 'Firmados',
                filters: { STATUS: [TransferenceStatus.NOTARIZED.id, TransferenceStatus.MANUAL.id].join(',') }
            },
            re_income: {
                id: 're_income',
                title: 'Reingresos',
                filters: { WITH_RE_INCOME: true, STATUS: [TransferenceStatus.NOTARY_APPROVAL.id].join(',') }
            },
            full: {
                id: 'full',
                title: 'Consultar todos',
                filters: {},
                sorted: { firma_notario: false }
            },
            history: {
                id: 'history',
                title: 'Historico',
                filters: {},
                sorted: { firma_notario: false }
            }
        };

        const recordCount = {
            forApproval: 0,
            repertory: 0,
            representation: 0,
            forSign: 0,
            signed: 0,
            re_income: 0,
            full: 0,
            history: 0
        };

        const listFilters = {
            forApproval: Object.assign({}, tabsDefinition.forApproval.filters),
            repertory: Object.assign({}, tabsDefinition.repertory.filters),
            representation: Object.assign({}, tabsDefinition.representation.filters),
            forSign: Object.assign({}, tabsDefinition.forSign.filters),
            signed: Object.assign({}, tabsDefinition.signed.filters),
            re_income: Object.assign({}, tabsDefinition.re_income.filters),
            full: Object.assign({}, tabsDefinition.full.filters),
            history: Object.assign({}, tabsDefinition.history.filters)
        };

        const hasTransferenceRepresentationNotarySee = AuthService.canDo(Permissions.TRANSFERENCE_REPRESENTATION_NOTARY_SEE);
        if (!hasTransferenceRepresentationNotarySee) {
            delete tabsDefinition.representation;
            delete listFilters.representation;
            delete recordCount.representation;
        }
        return { tabsDefinition, recordCount, listFilters };
    }

    toggleTab(tab) {
        if (this.state.activeTab !== tab) {
            const listFilters = this.state.listFilters;
            listFilters[tab] = this.state.tabsDefinition[tab].filters;
            this.setState({
                activeTab: tab,
                listFilters,
                filtersCollapsed: true
            });
            this.filterComponentRef.current.resetFilters();
        }
    }

    componentDidMount() {
        if (this.props.location.state) {
            this.setState({ activeTab: this.props.location.state.tab })
        }
        const recordCount = {};
        Object.keys(this.state.tabsDefinition).forEach(tabKey => {
            recordCount[tabKey] = 0;
        });
        this.setState({ recordCount });
    }

    toggleFilters() {
        this.setState({ filtersCollapsed: !this.state.filtersCollapsed });
    }

    buildFilters(tab, filters = null, sorted = null) {
        const where = filters || this.state.listFilters[tab];
        const sort = sorted || this.state.listSorted[tab];

        if (sort) {
            return { where: JSON.stringify(where), sorted: JSON.stringify(sort) };
        }

        return { where: JSON.stringify(where) };
    }

    setFiltersCallback(filters) {
        const tab = this.state.activeTab;
        const listFilters = this.state.listFilters;
        for (const filterKey in this.state.tabsDefinition[tab].filters) {
            if (this.state.tabsDefinition[tab].filters.hasOwnProperty(filterKey)) {
                if (filters.hasOwnProperty(filterKey)) {
                    const filterValue = this.state.tabsDefinition[tab].filters[filterKey].toString().split(',').filter(filterValue => filterValue.toString() === filters[filterKey].toString());
                    filters[filterKey] = filterValue.join(',');
                }
                else {
                    filters[filterKey] = this.state.tabsDefinition[tab].filters[filterKey];
                }
            }
        }
        listFilters[tab] = filters;
        this.setState({ listFilters });
        this.currentTableRef.current.refreshFilters(this.buildFilters(tab, listFilters[tab]));
    }

    setSortedCallback(sorted) {
        this.setState({ listSorted: sorted });
    }

    showDetailsInTabGeneric(filters, customTab) {
        console.log(`called ${JSON.stringify(filters)}`)
        const tab = customTab || this.state.tabsDefinition.full.id;
        const listFilters = Object.assign({}, this.state.listFilters);
        listFilters[tab] = filters;
        const newState = {
            activeTab: tab,
            filtersCollapsed: true
        };
        if (!customTab) {
            newState.listFilters = listFilters;
        }
        this.setState({ ...newState });
        if (!customTab) {
            setTimeout(() => {
                this.setFiltersCallback(listFilters[tab]);
            }, 100);
        }
    }

    onDismiss() {
        this.setState({ isMessageVisible: false });
    }

    showSuccesMessage(message) {
        this.setState({
            message: {
                success: true,
                text: message
            }, isMessageVisible: true
        })
    }

    showErrorMessage(message) {
        this.setState({
            message: {
                success: false,
                text: message
            }, isMessageVisible: true
        })
    }

    toggleShowModal() {
        if (this.state.showModal === true) {
            this.resetModal();
            return;
        }

        this.setState({ showModal: true });
    }

    resetModal() {
        this.setState({
            startDate: null,
            endDate: null,
            formData: {
                DATE_FROM: null,
                DATE_TO: null,
                DATE_RANGE: ''
            },
            loading: false,
            alert: null,
            downloadUrl: null,
            showModal: false,
            invalidDate: false,
        });
    }

    handleFormDataChange(event) {
        let newData = {};
        newData[event.target.id] = event.target.value;
        newData = Object.assign(this.state.formData, newData);
        this.setState({ formData: newData, invalidDate: false });
    }

    handleClearAlert() {
        if (this.state.loading) {
            return;
        }
        this.setState({ alert: null });
    }

    onDateRangeSelected(event, picker) {
        if (this.state.loading) {
            return;
        }

        this.setState({
            alert: null,
            downloadUrl: null,
        });
        const start = picker.startDate;
        const end = picker.endDate;

        const diffInMonths = end.diff(start, 'months', true); // true = decimal

        if (diffInMonths > 6) {
            this.setState({
                alert: {
                    type: 'warning',
                    message: 'Selecciona un rango de fecha válido para generar el listado, entre uno y 6 meses.',
                },
                formData: {
                    DATE_FROM: null,
                    DATE_TO: null,
                    DATE_RANGE: ''
                },
                invalidDate: true,
            });
            return;
        }


        const filterChangeEvent = {
            target: {
                id: 'DATE_RANGE',
                value: `${picker.startDate.format('DD/MM/YYYY')} - ${picker.endDate.format('DD/MM/YYYY')}`
            }
        };
        this.handleFormDataChange(filterChangeEvent);

        filterChangeEvent.target.id = 'DATE_FROM';
        filterChangeEvent.target.value = picker.startDate.format('YYYY-MM-DD');
        this.handleFormDataChange(filterChangeEvent);

        filterChangeEvent.target.id = 'DATE_TO';
        filterChangeEvent.target.value = picker.endDate.format('YYYY-MM-DD');
        this.handleFormDataChange(filterChangeEvent);
    }


    handleDownload = async () => {
        if (this.state.loading) {
            return;
        }

        const { DATE_FROM: startDate, DATE_TO: endDate } = this.state.formData;
        if (!startDate || !endDate) {
            this.setState({
                alert: {
                    type: 'warning',
                    message: 'Selecciona un rango de fecha válido para generar el listado.',
                },
            });
            return;
        }

        this.setState({ loading: true, alert: null });

        try {
            const resultDowload = await BackendApiService.sendToUAFROEExcelDownload(startDate, endDate);

            if (!resultDowload) {
                this.setState({
                    alert: {
                        type: 'danger',
                        message: 'No ha sido posible generar el archivo, por favor, intenta disminuyendo el rango de fechas seleccionado',
                    },
                    invalidDate: true,
                    loading: false,
                });
                return;
            }

            if (resultDowload && resultDowload.status) {
                const { status, message, data, error } = resultDowload;
                if (status === 200 && message === 'SUCCESS' && data.url) {
                    this.setState({
                        alert: {
                            type: 'success',
                            message: 'Listado CSV generado exitosamente.',
                        },
                        downloadUrl: data.url,
                        loading: false,
                    });
                    return;
                }

                if (status === 400 && error.includes('timeout')) {
                    this.setState({
                        alert: {
                            type: 'danger',
                            message: 'No ha sido posible generar el archivo, por favor, intenta disminuyendo el rango de fechas seleccionado',
                        },
                        loading: false,
                        invalidDate: true,
                    });
                    return;
                }

                if (status === 400 && error.includes('No transfer persons found')) {
                    this.setState({
                        alert: {
                            type: 'warning',
                            message: 'No se encontraron registros que coincidan con las fechas seleccionadas. Selecciona un nuevo rango.',
                        },
                        loading: false,
                        invalidDate: true,
                    });
                    return;
                }

                this.setState({
                    alert: {
                        type: 'danger',
                        message: 'Error al generar el listado. Por favor, inténtalo de nuevo. Si el problema persiste, contacta a soporte@autofact.cl',
                    },
                    loading: false,
                });
                return;
            }

            if (resultDowload && resultDowload.errno) {
                this.setState({
                    alert: {
                        type: 'danger',
                        message: 'Error al generar el listado. Por favor, inténtalo de nuevo. Si el problema persiste, contacta a soporte@autofact.cl',
                    },
                    loading: false,
                });
                return;
            }

            console.log('resultDowload', resultDowload);
            this.setState({
                alert: {
                    type: 'danger',
                    message: 'Error al generar el listado. Por favor, inténtalo de nuevo. Si el problema persiste, contacta a soporte@autofact.cl',
                },
                loading: false,
            });
            return;
        } catch (error) {
            this.setState({
                alert: {
                    type: 'danger',
                    message: 'Error al generar el listado. Por favor, inténtalo de nuevo. Si el problema persiste, contacta a soporte@autofact.cl',
                },
                loading: false,
            });
            return;
        }
    };

    render() {
        const { alert, activeTab } = this.state;
        const listMenu = [];
        switch (activeTab) {
            case 'repertory': {
                listMenu.push(
                    <CheckAccess permission={Permissions.TRANSFERENCE_REPERTORY_EDIT}>
                        <Link key={`massive-repertory`} className="btn btn-sm btn-primary-dark mr-2"
                            to={`transferencias/asignar-repertorio-masivo`}>Repertorios rápidos</Link>
                    </CheckAccess>
                );
                break;
            }
            case 'forSign': {
                listMenu.push(
                    <CheckAccess permission={Permissions.TRANSFERENCE_SIGN}>
                        <Link key={`massive-sign`} className="btn btn-sm btn-primary-dark mr-2"
                            to={`transferencias/firma-masiva`}>Firma masiva</Link>
                    </CheckAccess>);
                break;
            }
            case 'representation': {
                listMenu.push(
                    <CheckAccess permission={Permissions.TRANSFERENCE_REPRESENTATION_SIGNATURE_NOTARY_OFFICE}>
                        <Link key={`massive-sign`} className="btn btn-sm btn-primary-dark mr-2"
                            to={`transferencias/firma-masiva-representacion`}>Firma masiva</Link>
                    </CheckAccess>);
                break;
            }
            default: {
                break;
            }
        }
        let message = null;
        if (this.state.isMessageVisible) {
            message = <Alert className="mt-2" color={this.state.message.success ? 'success' : 'danger'}
                isOpen={this.state.isMessageVisible} toggle={this.onDismiss}>
                {this.state.message.text}
            </Alert>
        }
        return (
            <div>
                {message}
                <DashBoardHeaderContainer
                    showMore={this.showDetailsInTabGeneric}
                    showSuccesMessage={this.showSuccesMessage}
                    showErrorMessage={this.showErrorMessage}
                />
                <div className='col-md-12' id='menu-tabs'>
                    <div className='d-flex justify-content-between align-items-center tabs-dark nav nav-tabs px-2'>
                        <Nav tabs className="tabs-dark" id="contract-types">
                            {Object.keys(this.state.tabsDefinition).map((key, index) => {
                                const tab = this.state.tabsDefinition[key];
                                return (
                                    <NavItem key={`tab-nav-item-${index}`}>
                                        <NavLink
                                            key={`tab-nav-${index}`}
                                            className={activeTab === tab.id ? 'active' : ''}
                                            onClick={() => this.toggleTab(tab.id)}
                                        >
                                            {tab.title} ({this.state.recordCount[tab.id]})
                                        </NavLink>
                                    </NavItem>
                                );
                            })}
                        </Nav>
                        <Button id="declarations-button" className="btn btn-sm btn-primary-dark btn-outline-light border-white" onClick={this.toggleShowModal}>
                            Declaraciones  <img id="declarations-icon" src={DeclarationsIcon} alt="Declarations Icon" />
                        </Button>
                    </div>
                    <div class="d-flex justify-content-end mt-2">
                        {listMenu.length > 0 && (<NavItem className="nav-button">
                            {listMenu}
                        </NavItem>)}
                        <Button className="btn btn-sm btn-primary-dark" onClick={this.toggleFilters}>
                            <img className="filter-icon" src={FilterIcon} alt="Filter Icon" /> Filtros
                        </Button>
                    </div>
                </div>
                <Collapse isOpen={!this.state.filtersCollapsed}>
                    <div className="filter-form-wrapper">
                        <TransferenceListFilter ref={this.filterComponentRef}
                            defaultFilters={this.state.tabsDefinition[this.state.activeTab].filters}
                            activeTab={this.state.activeTab}
                            setFiltersCallback={this.setFiltersCallback} />
                    </div>
                </Collapse>
                <TabContent activeTab={activeTab}>
                    {Object.keys(this.state.tabsDefinition).map((key, index) => {
                        const tab = this.state.tabsDefinition[key];
                        return (
                            <TabPane tabId={tab.id} key={`tab-pane-${index}`}>
                                {activeTab === tab.id ?
                                    <TransferenceListContainer
                                        id={tab.id}
                                        tab={tab.id}
                                        ref={this.currentTableRef}
                                        key={`tab-list-${index}`}
                                        updateCount={count => {
                                            const recordCountState = this.state.recordCount;
                                            recordCountState[tab.id] = count;
                                            this.setState({ recordCount: recordCountState });
                                        }}
                                        filters={this.buildFilters(tab.id)}
                                    />
                                    :
                                    <div key={`tab-loading-${index}`}>Cargando</div>
                                }
                            </TabPane>
                        );
                    })}
                </TabContent>

                <Modal
                    id={"declarations-modal"}
                    isOpen={this.state.showModal}
                    toggle={this.toggleShowModal}
                    className={"modal-lg modal-dialog"}
                >
                    <div className="container-fluid">
                        <div className='modal-header-custom'>
                            <div className="left-section">
                                <img
                                    className="declarations-icon-black"
                                    src={DeclarationsIconBlack}
                                    alt="Declarations Icon Black"
                                />
                                <p className="modal-title">Listado de declaraciones Juradas</p>
                            </div>

                            <div className="close-icon" role="button" onClick={this.toggleShowModal}>
                                <img
                                    className="close-icon"
                                    src={GrayCloseIcon}
                                    alt="Close icon"
                                />
                            </div>
                        </div>
                    </div>
                    <ModalBody id={"declarations-modal-body"}>
                        <Form>
                            <div className="container-fluid">
                                <div>
                                    <p>
                                        Aquí puedes descargar las declaraciones juradas del comprador y del vendedor, conforme a lo solicitado por la Unidad de Análisis Financiero (UAF) en el marco del Reporte de Operaciones en Efectivo (ROE). Los datos disponibles son:
                                    </p>
                                </div>
                                {/* ✔ Declaraciones */}
                                <div className="mb-3">
                                    <div className="d-flex align-items-start mb-2 mt-3 check-item">
                                        <img
                                            className="check-icon"
                                            src={GreenCheckIcon}
                                            alt="Check"
                                        />
                                        <p className="mb-0">
                                            Declaración de Persona Políticamente Expuesta (PEP): identifica a personas con exposición política, en cumplimiento de las regulaciones.
                                        </p>
                                    </div>
                                    <div className="d-flex align-items-start mt-3 check-item">
                                        <img
                                            className="check-icon"
                                            src={GreenCheckIcon}
                                            alt="Check"
                                        />
                                        <p className="mb-0">
                                            Declaración de Origen de Fondos (DOF): para transacciones sobre los 10.000 USD, con el fin de prevenir el lavado de activos y el financiamiento del terrorismo.
                                        </p>
                                    </div>
                                </div>
                                <hr />

                                {/* 📅 Rango de búsqueda */}
                                <div className="mb-1 mt-2">
                                    <p className="darkblue-color bold mb-2">Selecciona un rango de búsqueda</p>
                                    <p className="mb-2">La descarga se limita a rangos de información de hasta 6 meses.</p>
                                </div>

                                <div className="form-group d-flex align-items-end flex-wrap">
                                    {/* Input de fechas */}
                                    <div className="mr-3 col-12 col-lg-6 pl-0">
                                        <label className='mb-2'>Rango de fecha</label>
                                        <DateRangePicker
                                            className="date-range-wrapper"
                                            onApply={this.onDateRangeSelected}
                                            ranges={
                                                {
                                                    'Último mes': [moment().subtract(1, 'month'), moment()],
                                                    'Últimos 3 meses': [moment().subtract(3, 'month'), moment()]
                                                }
                                            }
                                            locale={{
                                                format: 'DD/MM/YYYY',
                                                applyLabel: 'Aplicar',
                                                cancelLabel: 'Limpiar',
                                                fromLabel: 'Desde',
                                                toLabel: 'Hasta',
                                                customRangeLabel: 'Seleccionar rango',
                                                daysOfWeek: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
                                                monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                                                    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre',
                                                    'Diciembre'],
                                                firstDay: 1
                                            }}
                                            containerStyles={{ display: 'block' }}
                                        >
                                            <div className="date-input-wrapper">
                                                <Input
                                                    type="text"
                                                    placeholder="Selecciona fecha → Selecciona fecha"
                                                    id="DATE_RANGE"
                                                    className="form-control date-range-input height-range-picker"
                                                    readOnly
                                                    onClick={this.handleClearAlert}
                                                    onChange={this.handleFormDataChange}
                                                    value={this.state.formData.DATE_RANGE}
                                                />
                                                <img src={CalendarIcon} alt="Calendario" className="calendar-icon" />
                                            </div>
                                        </DateRangePicker>
                                    </div>

                                    {/* Botón CSV */}
                                    <div className='mt-2'>
                                        {!this.state.downloadUrl ? (
                                            <Button
                                                id="generate-button"
                                                className={`darkblue-background-color height-range-picker ${this.state.loading ? 'generate-button-loading' : ''
                                                    }`}
                                                disabled={this.state.formData.DATE_RANGE === '' || this.state.invalidDate}
                                                onClick={this.handleDownload}>
                                                {this.state.loading ? (
                                                    <>
                                                        Generando listado <FontAwesomeIcon icon={faSpinner} className="fa-1x" />
                                                    </>
                                                ) : (
                                                    'Generar listado CSV'
                                                )}
                                            </Button>
                                        ) : (
                                            <Button
                                                id="download-button"
                                                className="text-white height-range-picker orange-background-color"
                                                onClick={() => {
                                                    window.open(this.state.downloadUrl, '_blank');
                                                    this.setState({
                                                        alert: {
                                                            type: 'success',
                                                            message: 'La descarga se ha completado exitosamente.',
                                                        },
                                                    });
                                                }}
                                            >
                                                Descargar listado CSV <FontAwesomeIcon icon={faDownload} className="ml-2" />
                                            </Button>
                                        )}

                                    </div>
                                </div>
                            </div>
                        </Form>

                        {/* Alerta */}
                        {alert && (
                            <div className='container-fluid mt-4'>
                                <Alert color={alert.type} className="d-flex align-items-center">
                                    <FontAwesomeIcon
                                        icon={alertIconMap[alert.type]?.icon}
                                        className={`mr-3 ${alertIconMap[alert.type]?.color}`}
                                        style={{ fontSize: '1rem' }}
                                    />
                                    <span className="alert-text">{alert.message}</span>
                                </Alert>
                            </div>

                        )}
                        <div className={"justify-content-center mb-1 mt-4 text-center"}>
                            <Button
                                className="darkblue-color bold"
                                onClick={this.toggleShowModal}
                                color="link">
                                Salir
                            </Button>
                        </div>

                    </ModalBody>
                </Modal>
            </div >
        );
    }
}

export default withRouter(TransferenceList);
